"use client"
import dynamic from "next/dynamic"

const PageLoader = dynamic(() => import("@/components/Lottie/loader"), {
  ssr: false,
})

export default function PageLoaderAnimation() {
  return <PageLoader />
}
